import { ObjectSchema, object, string, number, boolean } from 'yup';
import { locale } from './../yup-locale';
import * as yup from 'yup';
import { edgeLineA, edgeLineB, MountType, OpsUnit } from './../../models/ops-unit';
import './../custom-method';

yup.setLocale(locale);

export const opsUnitLocationLenLimit = 20;
export const opsColorLenLimit = 8;

export function opsUnitValidator(): ObjectSchema<OpsUnit> {
    return object({
        id: string().uuid().strict(),
        vesselId: string().uuid().strict(),
        index: number().required().nonNullable().strict(),
        LineAIp: string()
            .isIp()
            .required()
            .nonNullable()
            .strict()
            .notOneOf([edgeLineA], 'errors.validation.generic.ip-address-edge'),
        LineBIp: string()
            .isIp()
            .required()
            .nonNullable()
            .strict()
            .notOneOf([edgeLineB], 'errors.validation.generic.ip-address-edge'),
        location: string().required().nonNullable().strict().max(opsUnitLocationLenLimit),
        allCategoriesSelected: boolean().required().nonNullable().strict(),
        mountType: string().required().nonNullable().strict().oneOf(Object.values(MountType)),
        sunshade: boolean().required().nonNullable().strict(),
        EMC: boolean().required().nonNullable().strict(),
        ethernetExtraLength: boolean().required().nonNullable().strict(),
        keyboard: boolean().required().nonNullable().strict(),
        color: string().nullable().strict().max(opsColorLenLimit),
    })
        .strict()
        .noUnknown();
}
